/**
 * Site-wide Lipscore reviews popup.
 * Opens when clicking .lipscore-rating-small, .lipscore-rating, or [data-lipscore-reviews-open].
 */
(function () {
  'use strict';

  var modal = null;
  var closeBtn = null;
  var titleEl = null;
  var ratingLine = null;
  var reviewsRoot = null;
  var layoutFixTimer = null;
  var lipscoreRetryTimer = null;
  var lipscoreObserver = null;
  var cleanupRunning = false;
  var currentProductKey = '';

  function getSettings() {
    return window.LipscoreReviewsPopupSettings || {};
  }

  function isPopupEnabledHere() {
    var s = getSettings();
    var type = s.pageType || '';

    // Only an explicit false disables (unset keeps on-by-default behaviour)
    if (type === 'index') return s.homepage !== false;
    if (type === 'product') return s.product !== false;
    if (type === 'collection' || type === 'list-collections' || type === 'search') {
      return s.collection !== false;
    }

    // Other templates that may show product cards follow the collection toggle
    return s.collection !== false;
  }

  function syncEnabledClass() {
    if (isPopupEnabledHere()) {
      document.documentElement.classList.add('ls-reviews-popup-enabled');
    } else {
      document.documentElement.classList.remove('ls-reviews-popup-enabled');
    }
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function ensureEls() {
    modal = qs('#lipscore-reviews-popup');
    if (!modal) return false;
    closeBtn = qs('[data-ls-popup-close]', modal);
    titleEl = qs('[data-ls-popup-title]', modal);
    ratingLine = qs('[data-ls-popup-rating]', modal);
    reviewsRoot = qs('#lipscore-review-list-popup', modal);
    return !!(reviewsRoot && titleEl);
  }

  function reinitLipscore() {
    if (window.lipscore && typeof window.lipscore.reInitWidgets === 'function') {
      window.lipscore.reInitWidgets(true);
      return true;
    }
    if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
      window.lipscore.initWidgets();
      return true;
    }
    return false;
  }

  function setHeaderRating(text) {
    if (!ratingLine) return;
    if (!text) {
      ratingLine.hidden = true;
      ratingLine.textContent = '';
      return;
    }
    ratingLine.hidden = false;
    ratingLine.textContent = text;
  }

  function hideNode(node) {
    if (!node || node === reviewsRoot) return false;
    node.setAttribute('data-ls-popup-summary', 'true');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
    node.style.setProperty('margin', '0', 'important');
    node.style.setProperty('padding', '0', 'important');
    return true;
  }

  function isReviewCardContainer(text) {
    return (text.match(/\bBUYER\b/gi) || []).length >= 1;
  }

  function hideBrokenLipscoreSummary() {
    if (!reviewsRoot) return false;
    var root = reviewsRoot;
    var hidden = false;
    var i;
    var el;
    var text;

    function consider(node) {
      if (!node || node === root) return;
      text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      var hasFilter = /Filter by star rating/i.test(text) || /^Filter$/i.test(text);
      var hasBasedOn = /Based On\s+\d+\s+Ratings/i.test(text);
      if ((hasFilter || hasBasedOn) && !isReviewCardContainer(text)) {
        if (hideNode(node)) hidden = true;
      }
    }

    var topLevel = root.children;
    for (i = 0; i < topLevel.length; i++) {
      consider(topLevel[i]);
      var kids = topLevel[i].children;
      for (var k = 0; k < kids.length; k++) {
        consider(kids[k]);
        var grand = kids[k].children;
        for (var g = 0; g < grand.length; g++) consider(grand[g]);
      }
    }

    var all = root.querySelectorAll('div, span, p, section, header, aside, button, label');
    for (i = 0; i < all.length; i++) {
      el = all[i];
      text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/Filter by star rating/i.test(text)) continue;
      if (text.length > 40 && !/^Filter by star rating/i.test(text)) continue;

      var candidate = null;
      var node = el;
      for (var depth = 0; depth < 12 && node && node !== root; depth++) {
        var nt = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (isReviewCardContainer(nt)) break;
        if (/Based On\s+\d+\s+Ratings/i.test(nt) || /Filter by star rating/i.test(nt)) {
          candidate = node;
        }
        node = node.parentElement;
      }
      if (candidate && hideNode(candidate)) hidden = true;
    }

    for (i = 0; i < all.length; i++) {
      el = all[i];
      text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^Filter$/i.test(text)) continue;
      var bar = el.parentElement;
      if (bar && bar !== root) {
        var barText = (bar.textContent || '').replace(/\s+/g, ' ').trim();
        if (barText.length <= 24 && !isReviewCardContainer(barText)) {
          if (hideNode(bar)) hidden = true;
          continue;
        }
      }
      if (hideNode(el)) hidden = true;
    }

    var rootText = (root.textContent || '').replace(/\s+/g, ' ').trim();
    var ratingMatch = rootText.match(/(\d+\.\d+)\s+Based On\s+(\d+)\s+Ratings(?:\s+And\s+(\d+)\s+Reviews)?/i);
    if (ratingMatch) {
      var ratingText = ratingMatch[1] + ' \u2605  based on ' + ratingMatch[2] + ' ratings';
      if (ratingMatch[3]) ratingText += ' and ' + ratingMatch[3] + ' reviews';
      setHeaderRating(ratingText);
    }

    if (hidden || root.querySelector('[class*="review"], article, li')) {
      root.removeAttribute('data-ls-popup-loading');
    }

    return hidden;
  }

  function scheduleLipscoreCleanup() {
    if (layoutFixTimer) window.clearInterval(layoutFixTimer);
    var tries = 0;
    layoutFixTimer = window.setInterval(function () {
      if (cleanupRunning) return;
      cleanupRunning = true;
      tries += 1;
      var done = false;
      try {
        done = hideBrokenLipscoreSummary();
      } finally {
        cleanupRunning = false;
      }
      if (done || tries > 40) {
        window.clearInterval(layoutFixTimer);
        layoutFixTimer = null;
        if (reviewsRoot) reviewsRoot.removeAttribute('data-ls-popup-loading');
      }
    }, 200);

    if (reviewsRoot && window.MutationObserver) {
      if (lipscoreObserver) lipscoreObserver.disconnect();
      lipscoreObserver = new MutationObserver(function () {
        if (cleanupRunning) return;
        cleanupRunning = true;
        try {
          hideBrokenLipscoreSummary();
        } finally {
          cleanupRunning = false;
        }
      });
      lipscoreObserver.observe(reviewsRoot, { childList: true, subtree: true });
    }
  }

  function hydrateReviews() {
    var ready = reinitLipscore();
    scheduleLipscoreCleanup();
    if (ready) return;
    var attempts = 0;
    if (lipscoreRetryTimer) window.clearInterval(lipscoreRetryTimer);
    lipscoreRetryTimer = window.setInterval(function () {
      attempts += 1;
      if (reinitLipscore() || attempts > 40) {
        window.clearInterval(lipscoreRetryTimer);
        lipscoreRetryTimer = null;
        scheduleLipscoreCleanup();
      }
    }, 250);
  }

  function getSourceEl(trigger) {
    if (!trigger) return null;
    if (trigger.hasAttribute && trigger.hasAttribute('data-ls-product-id')) {
      return trigger;
    }
    if (trigger.classList && (trigger.classList.contains('lipscore-rating-small') || trigger.classList.contains('lipscore-rating'))) {
      return trigger;
    }
    return (
      trigger.closest('[data-ls-product-id]') ||
      qs('.lipscore-rating-small', trigger) ||
      qs('.lipscore-rating', trigger) ||
      trigger.closest('.lipscore-rating-small') ||
      trigger.closest('.lipscore-rating') ||
      trigger
    );
  }

  function productKeyFrom(el) {
    if (!el) return '';
    return (
      el.getAttribute('data-ls-product-id') ||
      el.getAttribute('data-ls-sku') ||
      el.getAttribute('data-ls-product-url') ||
      el.getAttribute('data-ls-product-name') ||
      ''
    );
  }

  function applyProductData(fromEl) {
    if (!fromEl || !reviewsRoot) return;
    var attrs = [
      'data-ls-product-name',
      'data-ls-brand',
      'data-ls-product-id',
      'data-ls-product-url',
      'data-ls-variant-id',
      'data-ls-variant-name',
      'data-ls-sku',
      'data-ls-description',
      'data-ls-image-url',
      'data-ls-price',
      'data-ls-price-currency',
      'data-ls-availability',
      'data-ls-category',
      'data-ls-gtin'
    ];
    // Clear previous Lipscore markup so widgets re-bind cleanly
    reviewsRoot.innerHTML = '';
    attrs.forEach(function (name) {
      var val = fromEl.getAttribute(name);
      if (val != null && val !== '') {
        reviewsRoot.setAttribute(name, val);
      } else {
        reviewsRoot.removeAttribute(name);
      }
    });
    if (!reviewsRoot.getAttribute('data-ls-gtin')) {
      reviewsRoot.setAttribute('data-ls-gtin', '');
    }

    var name = fromEl.getAttribute('data-ls-product-name') || 'Customer reviews';
    titleEl.textContent = name;
    setHeaderRating('');
  }

  function openPopup(trigger) {
    if (!isPopupEnabledHere()) return;
    if (!ensureEls()) return;
    var source = getSourceEl(trigger);
    if (!source) return;

    var key = productKeyFrom(source);
    var productChanged = key && key !== currentProductKey;
    currentProductKey = key || currentProductKey;

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    if (productChanged || !reviewsRoot.getAttribute('data-ls-product-id')) {
      applyProductData(source);
      reviewsRoot.setAttribute('data-ls-popup-loading', 'true');
    }

    modal.hidden = false;
    document.body.classList.add('ls-reviews-popup-open');
    modal.scrollTop = 0;
    var body = qs('.ls-reviews-popup__body', modal);
    if (body) body.scrollTop = 0;
    if (closeBtn) closeBtn.focus();

    window.setTimeout(function () {
      hydrateReviews();
    }, 50);
  }

  function closePopup() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('ls-reviews-popup-open');
    if (lipscoreObserver) {
      lipscoreObserver.disconnect();
      lipscoreObserver = null;
    }
    if (layoutFixTimer) {
      window.clearInterval(layoutFixTimer);
      layoutFixTimer = null;
    }
    if (lipscoreRetryTimer) {
      window.clearInterval(lipscoreRetryTimer);
      lipscoreRetryTimer = null;
    }
  }

  function isReviewsTrigger(el) {
    if (!el || !el.closest) return null;
    if (el.closest('[class*="service-review"]')) return null;
    return (
      el.closest('[data-lipscore-reviews-open]') ||
      el.closest('.lipscore-rating-small') ||
      el.closest('.lipscore-rating')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var closeTarget = event.target.closest && event.target.closest('[data-ls-popup-close]');
      if (closeTarget) {
        event.preventDefault();
        closePopup();
        return;
      }

      if (!isPopupEnabledHere()) return;

      var trigger = isReviewsTrigger(event.target);
      if (!trigger) return;

      // Don't steal clicks from form controls inside Lipscore widgets (except the star rating itself)
      if (event.target.closest('input, textarea, select, button:not([data-lipscore-reviews-open])')) {
        if (!event.target.closest('.lipscore-rating-small, .lipscore-rating, [data-lipscore-reviews-open]')) {
          return;
        }
      }

      event.preventDefault();
      event.stopPropagation();
      openPopup(trigger);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePopup();
      return;
    }
    if (!isPopupEnabledHere()) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = isReviewsTrigger(event.target);
    if (!trigger) return;
    event.preventDefault();
    openPopup(trigger);
  });

  syncEnabledClass();

  // Expose for manual opens (e.g. bundle banner)
  window.LipscoreReviewsPopup = {
    open: openPopup,
    close: closePopup,
    isEnabled: isPopupEnabledHere
  };
})();
